import { useNavigate } from 'react-router-dom'
import ApiClient from '../lib/api-client'

function fetchLogout () {
  return ApiClient.post('/auth/logout', {
    refreshToken: ApiClient.refreshToken
  })
}

function clearTokens () {
  ApiClient.setRefreshToken('')
  ApiClient.setToken('')
}

function useLogout () {
  const navigate = useNavigate()

  const logout = (url = 0) => {
    fetchLogout()
      .then(() => {
        clearTokens()
        navigate(url, { replace: true })
      })
      .catch(() => {
        clearTokens()
        navigate(url, { replace: true })
      })
  }

  return logout
}

export default useLogout
